export const DocumentType = {
  "GoodsDispatched": "Dokument WZ",
  "GoodsReceived": "Dokument PZ",
  "ReceiptWeight": "Kwit wagowy",
  "Other": "Inne"
}